import type { PatientDetail } from '#shared/types';
import { api } from '#client/lib/api';
import { ENDPOINT } from '#client/lib/endpoints';
import type { PaymentBody } from './payment.logic';

/** Appends a payment, or a refund, to the visit's ledger. */
export function recordPayment(patientId: number, input: PaymentBody): Promise<PatientDetail> {
  return api.post<PatientDetail>(ENDPOINT.patientPayments(patientId), input);
}
